import type { DrawerProps as MantineDrawerProps } from '@mantine/core';
import { Drawer as MantineDrawer } from '@mantine/core';

type DrawerProps = MantineDrawerProps;
export const DrawerDefaultProps = (): Partial<DrawerProps> => ({
  lockScroll: true,
});

type DrawerWrapperProps = Partial<MantineDrawerProps>;

export const Drawer = MantineDrawer;

export type { DrawerProps, DrawerWrapperProps };
